module.exports = __webpack_public_path__ + "img/j.58d7b972.jpg";